export default {
  exportHeader: 'Export Kopfzeile',
};
